

export const socketEvents = {
  updateJobs: "update-jobs",
  leaveJob: "leave-job",
  updateCommunications: "update-communications",
}
